import React from "react";

import { MissingAddressTypeFieldAlert, UnknownAddressTypesAlert } from "fond/project/addressTypes";

import { AddressTypeCheck } from "./useAddressTypeCheck";

type AddressTypeAlertsProps = Pick<
  AddressTypeCheck,
  "unknownAddressTypes" | "addressTypeFieldMissing" | "featureCollection" | "identifyUnknownAddressTypes"
>;

/**
 * Warnings about unknown address types, or a missing address type field with a picker for another field.
 */
const AddressTypeAlerts: React.FC<AddressTypeAlertsProps> = ({
  unknownAddressTypes,
  addressTypeFieldMissing,
  featureCollection,
  identifyUnknownAddressTypes,
}) => (
  <>
    {unknownAddressTypes.length > 0 && <UnknownAddressTypesAlert unknownAddressTypes={unknownAddressTypes} />}
    {addressTypeFieldMissing && (
      <MissingAddressTypeFieldAlert featureCollection={featureCollection} identifyUnknownAddressTypes={identifyUnknownAddressTypes} />
    )}
  </>
);

export default AddressTypeAlerts;
